import axios from "axios";
import { IAxiosBlankReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

export interface DeleteHierarchyCommentDetails {
  hierarchyId: string;
  commentId: string;
}
export interface DeleteTlfItemCommentDetails {
  id: string;
  azsolId: string;
  version: number;
  commentId: string;
}

/**
 * Delete a comment from a hierarchy or TLF item.
 *
 * @param backEndUrl - Base backend URL
 * @param details - Details identifying the comment to delete
 * @param controller - AbortController to cancel the request
 * @returns IAxiosReturn indicating success or failure
 */
export const deleteComment = async (
  backEndUrl: string,
  details: DeleteHierarchyCommentDetails | DeleteTlfItemCommentDetails,
  controller: AbortController,
): Promise<IAxiosBlankReturn> => {
  try {
    if ((details as DeleteHierarchyCommentDetails).hierarchyId) {
      const hdets = details as DeleteHierarchyCommentDetails;
      const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comment/${hdets.commentId}`;
      await axios.delete(url, { signal: controller.signal });
      return { success: true };
    } else {
      const tdets = details as DeleteTlfItemCommentDetails;
      const url = `${backEndUrl}TlfItems/${tdets.id}/Comment/${tdets.commentId}`;
      await axios.delete(url, { signal: controller.signal });
      return { success: true };
    }
  } catch (error) {
    return processAxiosError("Delete comment failed", error);
  }
};
